var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BlockWithLoader',{attrs:{"blocked":_vm.loading}},[_c('p-panel',{staticClass:"hidden-panel"},[_c('LoaderSpinner',{attrs:{"loading":_vm.loading}}),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }